import Cookie from 'coreClasses/cookies/Cookie';
import CookiesMgr from 'coreClasses/cookies/CookiesMgr';
import {CMS_SCHEDULED_AT_COOKIE} from 'coreUtils/cms/contentHubConnection';

const isValidDate = (date: Date): boolean => !isNaN(date.getTime());

export const persistScheduledDate = (date: Date): void => {
	if (!isValidDate(date)) {
		return;
	}

	CookiesMgr.setCookie(
		new Cookie(CMS_SCHEDULED_AT_COOKIE, date.toISOString(), {path: '/'}),
	);
};

export const getScheduledDate = (): Date | null => {
	const value = CookiesMgr.getCookie(CMS_SCHEDULED_AT_COOKIE)?.getValue();

	return value ? new Date(value) : null;
};

export const clearScheduledDate = (): void => {
	CookiesMgr.removeCookie(CMS_SCHEDULED_AT_COOKIE);
};

export const toISOWithoutMs = (date: Date): string => {
	if (!isValidDate(date)) {
		return '';
	}

	return date.toISOString().split('.')[0] + 'Z';
};